export default function SearchParamGenerator(q) {
  const keys = Object.keys(q);
  const paramList = [];
  for (let key of keys) {
    if (q[key]) {
      paramList.push(`${key}=${q[key]}`);
    }
  }
  return paramList.join("&");
}
